import { Link } from '@amzn/awsui-components-core';
import { convertEntities } from '@amzn/awscat-editor';
import { ContentRequest } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { getContentRequestLink } from './ContentRequestColumnDefinition';

export interface Props {
  contentRequest: ContentRequest;
}

const ContentRequestLink: React.FunctionComponent<Props> = (props: Props) => {
  const { contentRequest } = props;
  const appContext = useContext(AppContext);
  return (
    <Link variant="secondary" target="_blank" href={getContentRequestLink(contentRequest)}>
      {convertEntities(contentRequest.contentRequestData.contentName, appContext.entities)}
    </Link>
  );
};

export default ContentRequestLink;
